import { WIDGET_CONTROL_TYPE } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

export const CUBIC_GENERAL_PRESET: GraphpadWidgetConfig = {
  id: 'cubic-general',
  type: 'graphpad',
  params: {
    f: { type: 'cubic-general', params: { a: 1, b: -3, c: 0, d: 2 } },
    'f-translate': { type: 'handle', params: { of: 'f', behavior: 'translate' } },
    'f-roots': { type: 'roots', params: { of: 'f' } },
    'f-extrema': { type: 'extrema', params: { of: 'f' } },
    'f-inflection': { type: 'inflection', params: { of: 'f' } },
    'y-intercept': { type: 'yIntercept', params: { of: 'f' } },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -5, xEnd: 5, yStart: -10, yEnd: 10 },
      grid: { type: 'lines', visible: false },
    },
    elements: {
      'f-roots': { point: { label: { contentVariant: 'name+coord', position: 'topLeft' } } },
      'f-extrema': { point: { label: { contentVariant: 'name+coord', position: 'topLeft' } } },
      'f-inflection': { point: { label: { contentVariant: 'name+coord', position: 'topLeft' } } },
      'y-intercept': { point: { label: { contentVariant: 'name+coord', position: 'topLeft' } } },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-a',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'a (cubic)',
        param: 'f.a',
        range: [-2, 2, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'indigo',
      },
      {
        id: 'slider-b',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'b (quadratic)',
        param: 'f.b',
        range: [-5, 5, 0.5],
        defaultValue: -3,
        editable: true,
        color: 'green',
      },
      {
        id: 'slider-c',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'c (linear)',
        param: 'f.c',
        range: [-5, 5, 0.5],
        defaultValue: 0,
        editable: true,
        color: 'amber',
      },
      {
        id: 'slider-d',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'd (constant)',
        param: 'f.d',
        range: [-5, 5, 0.5],
        defaultValue: 2,
        editable: true,
        color: 'pink',
      },
    ],
  },
};
